const setActiveSurveys = (state, payload) => {
  state.surveys = payload
}

export default {
  setActiveSurveys,
}
